import { render } from "./basket.vue?vue&type=template&id=266602b8&scoped=true"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"

import "./basket.vue?vue&type=style&index=0&id=266602b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266602b8"]])

export default __exports__